
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wildfire",
      function () {
        return require("private-next-pages/wildfire.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wildfire"])
      });
    }
  